import styled from '@emotion/styled'
import { Field, ErrorMessage } from 'formik'
import React from 'react'

export default React.memo(
  ({
    name,
    label,
    type = null,
    children,
    fieldComponent,
    className,
    ...passthrough
  }) => (
    <Container className={className}>
      <LabelErrorContainer>
        {label && (
          <label
            htmlFor={name}
            className={passthrough.required ? 'required' : ''}
          >
            {label}
          </label>
        )}
        <ErrorWrapper>
          <ErrorMessage name={name} />
        </ErrorWrapper>
      </LabelErrorContainer>
      {fieldComponent ? (
        fieldComponent({ id: name, name, ...passthrough })
      ) : (
        <Field id={name} name={name} type={type} {...passthrough}>
          {children && children}
        </Field>
      )}
    </Container>
  ),
)

const Container = styled.div`
  min-width: 240px;
  text-align: left;
`

export const LabelErrorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  margin: 0 8px 2px;
`

export const ErrorWrapper = styled.span`
  font-size: 1.7rem;
  font-weight: 600;
  color: ${(p) => p.theme.colors.alert};
`
